import api, { toUserError } from './api'

export function normalizeProject(project) {
  if (!project) return null
  return {
    id: String(project.id || project._id || ''),
    name: project.name || '',
    sourceFolderName: project.sourceFolderName || '',
    description: project.description || '',
    active: project.active !== false,
    createdBy: project.createdBy ? String(project.createdBy) : '',
    updatedBy: project.updatedBy ? String(project.updatedBy) : '',
    createdAt: project.createdAt || null,
    updatedAt: project.updatedAt || null,
  }
}

export function normalizePartProjects(list) {
  if (!Array.isArray(list)) return []
  const seen = new Set()
  const items = []
  for (const item of list) {
    const projectId = String(item?.projectId || item?.id || '').trim()
    if (!projectId || seen.has(projectId)) continue
    seen.add(projectId)
    items.push({
      projectId,
      projectName: item?.projectName || item?.name || '',
    })
  }
  return items
}

/** ProjectPicker 등: page 없이 전체(또는 active) 목록 */
export async function fetchProjects(params = {}) {
  try {
    const query = {}
    Object.entries(params).forEach(([key, value]) => {
      if (value == null || value === '') return
      if (key === 'page' || key === 'limit') return
      query[key] = value
    })
    const { data } = await api.get('/projects', { params: query })
    const payload = data.data || {}
    return (payload.projects || payload.items || []).map(normalizeProject)
  } catch (error) {
    throw toUserError(error)
  }
}

/** 설정 → 프로젝트 관리: 서버 사이드 pagination */
export async function fetchProjectsPage(params = {}) {
  try {
    const query = {}
    Object.entries(params).forEach(([key, value]) => {
      if (value == null || value === '' || value === 'all') return
      query[key] = value
    })
    const { data } = await api.get('/projects', { params: query })
    const payload = data.data || {}
    const items = (payload.items || payload.projects || []).map(normalizeProject)
    const total = Number(payload.total ?? payload.count ?? items.length) || 0
    const limit = Number(payload.limit) || items.length || 20
    const page = Number(payload.page) || 1
    const totalPages = Number(payload.totalPages) || Math.max(1, Math.ceil(total / (limit || 1)))
    return { items, total, page, limit, totalPages, count: items.length }
  } catch (error) {
    throw toUserError(error)
  }
}

export async function createProject(payload) {
  try {
    const { data } = await api.post('/projects', payload)
    return normalizeProject(data.data?.project)
  } catch (error) {
    throw toUserError(error)
  }
}

export async function updateProject(id, payload) {
  try {
    const { data } = await api.put(`/projects/${id}`, payload)
    return normalizeProject(data.data?.project)
  } catch (error) {
    throw toUserError(error)
  }
}
